import { Link } from 'react-router-dom'
import styles from './ProductCard.module.css'

interface ProductCardProps {
  product: {
    id: string
    title: string
    price: number
    images: string[]
    status: 'available' | 'sold' | 'reserved'
  }
}

export default function ProductCard({ product }: ProductCardProps) {
  const isSold = product.status === 'sold'

  return (
    <Link to={`/products/${product.id}`} className={styles.card}>
      <div className={styles.imageWrapper}>
        <img
          src={product.images[0] || 'https://placehold.co/300x300?text=No+Image'}
          alt={product.title}
        />
        {isSold && <span className={styles.soldBadge}>SOLD</span>}
      </div>
      <div className={styles.info}>
        <p className={styles.title}>{product.title}</p>
        <p className={styles.price}>&yen;{product.price.toLocaleString()}</p>
      </div>
    </Link>
  )
}
